export const PERMISSION = {
  VALI_USER_CREATE: 'VALI_USER_CREATE',
  VALI_USER_UPDATE: 'VALI_USER_UPDATE',
  VALI_USER_LIST: 'VALI_USER_LIST',
  VALI_USER_DETAIL: 'VALI_USER_DETAIL',
  VALI_USER_DELETE: 'VALI_USER_DELETE',

  VALI_USER_COMPANY_CREATE: 'VALI_USER_COMPANY_CREATE',
  VALI_USER_COMPANY_UPDATE: 'VALI_USER_COMPANY_UPDATE',
  VALI_USER_COMPANY_LIST: 'VALI_USER_COMPANY_LIST',
  VALI_USER_COMPANY_DETAIL: 'VALI_USER_COMPANY_DETAIL',
  VALI_USER_COMPANY_DELETE: 'VALI_USER_COMPANY_DELETE',

  VALI_COMPETITION_CREATE: 'VALI_COMPETITION_CREATE',
  VALI_COMPETITION_UPDATE: 'VALI_COMPETITION_UPDATE',
  VALI_COMPETITION_LIST: 'VALI_COMPETITION_LIST',
  VALI_COMPETITION_DETAIL: 'VALI_COMPETITION_DETAIL',
  VALI_COMPETITION_DELETE: 'VALI_COMPETITION_DELETE',
  VALI_COMPETITION_VALIDATE: 'VALI_COMPETITION_VALIDATE',
  VALI_COMPETITION_LIST_MATCHING: 'VALI_COMPETITION_LIST_MATCHING',

  VALI_IMAGE_CREATE: 'VALI_IMAGE_CREATE',
  VALI_IMAGE_DETAIL: 'VALI_IMAGE_DETAIL',
  VALI_IMAGE_DELETE: 'VALI_IMAGE_DELETE',

  VALI_KKV_DETAIL: 'VALI_KKV_DETAIL',

  VALI_COMPETITION_APPROVE: 'VALI_COMPETITION_APPROVE',

  VALI_COMPLEX_CONDITION_CREATE: 'VALI_COMPLEX_CONDITION_CREATE',
  VALI_COMPLEX_CONDITION_UPDATE: 'VALI_COMPLEX_CONDITION_UPDATE',
  VALI_COMPLEX_CONDITION_DETAIL: 'VALI_COMPLEX_CONDITION_DETAIL',
  VALI_COMPLEX_CONDITION_LIST: 'VALI_COMPLEX_CONDITION_LIST',
  VALI_COMPLEX_CONDITION_DELETE: 'VALI_COMPLEX_CONDITION_DELETE',
  VALI_COMPLEX_CONDITION_SUBPAGE: 'VALI_COMPLEX_CONDITION_SUBPAGE',

  VALI_CURRENT_PROGRAM_CREATE: 'VALI_CURRENT_PROGRAM_CREATE',
  VALI_CURRENT_PROGRAM_UPDATE: 'VALI_CURRENT_PROGRAM_UPDATE',
  VALI_CURRENT_PROGRAM_DETAIL: 'VALI_CURRENT_PROGRAM_DETAIL',
  VALI_CURRENT_PROGRAM_LIST: 'VALI_CURRENT_PROGRAM_LIST',
  VALI_CURRENT_PROGRAM_DELETE: 'VALI_CURRENT_PROGRAM_DELETE',
  VALI_CURRENT_PROGRAM_APPROVE: 'VALI_CURRENT_PROGRAM_APPROVE',
  VALI_CURRENT_PROGRAM_REORDER: 'VALI_CURRENT_PROGRAM_REORDER',

  VALI_PRIVATE_SERVICES_CREATE: 'VALI_PRIVATE_SERVICES_CREATE',
  VALI_PRIVATE_SERVICES_UPDATE: 'VALI_PRIVATE_SERVICES_UPDATE',
  VALI_PRIVATE_SERVICES_DETAIL: 'VALI_PRIVATE_SERVICES_DETAIL',
  VALI_PRIVATE_SERVICES_LIST: 'VALI_PRIVATE_SERVICES_LIST',
  VALI_PRIVATE_SERVICES_DELETE: 'VALI_PRIVATE_SERVICES_DELETE',
  VALI_PRIVATE_SERVICES_APPROVE: 'VALI_PRIVATE_SERVICES_APPROVE',
  VALI_PRIVATE_SERVICES_REORDER: 'VALI_PRIVATE_SERVICES_REORDER',

  VALI_ROLE_CREATE: 'VALI_ROLE_CREATE',
  VALI_ROLE_UPDATE: 'VALI_ROLE_UPDATE',
  VALI_ROLE_DETAIL: 'VALI_ROLE_DETAIL',
  VALI_ROLE_LIST: 'VALI_ROLE_LIST',
  VALI_ROLE_DELETE: 'VALI_ROLE_DELETE',

  VALI_NEWS_CREATE: 'VALI_NEWS_CREATE',
  VALI_NEWS_UPDATE: 'VALI_NEWS_UPDATE',
  VALI_NEWS_DETAIL: 'VALI_NEWS_DETAIL',
  VALI_NEWS_LIST: 'VALI_NEWS_LIST',
  VALI_NEWS_DELETE: 'VALI_NEWS_DELETE',
  VALI_NEWS_APPROVE: 'VALI_NEWS_APPROVE',
  VALI_NEWS_REORDER: 'VALI_NEWS_REORDER'
}
